export enum PaymentGateway {
  STRIPE = 'STRIPE',
}

export enum PaymentOptions {
  AUTO_CHARGE = 'AUTO_CHARGE',
  PAYMENT_LINK = 'PAYMENT_LINK',
  BANK_TRANSFER = 'BANK_TRANSFER',
}
